/*@ngInject*/
const urlLinkController = function ($scope, $window, $controller, coreMediator, xmlUtil) {

    angular.extend(this, $controller('baseFormComponentController', {$scope: $scope}));

    this.$onInit = function () {
        $scope.openLink = function () {
            let fieldStructure = this.$parent.$ctrl.fieldStructure,
                fieldModel = fieldStructure.fieldModel,
                submissionId,
                formId,
                formName,
                variableName,
                link,
                uiFieldOptions;

            if (fieldModel) {
                uiFieldOptions = xmlUtil.parseString(fieldStructure.uiField.options);
                if (uiFieldOptions.logAccess) {
                    coreMediator.getSingleUseToken().then((token) => {
                        submissionId = fieldStructure.parentForm.submissionId;
                        formId = fieldStructure.parentForm.id;
                        formName = fieldStructure.parentForm.name;
                        variableName = fieldModel.name;
                        link = `/mvc/link?l=${fieldModel.value}&s=${submissionId}&f=${formId}&n=${encodeURIComponent(formName)}&v=${variableName}&t=${encodeURIComponent(token)}`;
                        $window.open(link, '_blank');
                    });
                } else {
                    $window.open(fieldModel.value, '_blank');
                }
            }
        };
    };

    this.getLabelText = function () {
        const valueLabel = this.fieldStructure.fieldModel ? this.fieldStructure.fieldModel.valueLabel : null;
        if (!_.isNil(valueLabel)) {
            return valueLabel;
        }
        return this.fieldStructure.uiField.displayLabel;
    };
};

angular.module('umFormViewer')
    .controller('urlLinkController', urlLinkController);
